import template from './progressBar.html';
import { ProgressBarController as controller } from './progressBar.controller';

export default {
  restrict: 'E',
  bindings: {
    states: '<',
    show: '@'
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/common/ui/progressBar/progressBar.component.js